import FieldOverview from '@commons/cards/fieldOverview'
import { useSelector } from 'react-redux'
import {
  StyleAvailabilityItem,
  StyleAvailabilityItems,
  StyleAvailabilityWrapper,
  StyleTimeWrapper,
} from './style'
import { Constant } from '@utils'
import { Fragment } from 'react/jsx-runtime'
import Typography from '@components/typography'
import { useState } from 'react'
import Column from '@components/column'
import Modal from '@components/modal'
import { Formik, Form } from 'formik'
import Fields from '@components/fields'
import Row from '@components/row'
import Button from '@components/button'
import { Availability } from '@apis'
import { AvailabilitySchema } from '@validations'
import Svg from '@components/svg'
import { store, Actions } from '@store'
const today = new Date()
const weekday = today.toLocaleDateString('en-US', { weekday: 'long' })
const Availabilities = () => {
  const { data: user } = useSelector((state: any) => state.user)
  const [visible, setVisible] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(false)
  const currentSlot = user?.availabilities?.find(
    (availability) => availability?.day == weekday,
  )
  const [initialValues, setInitialValues] = useState({
    id: null,
    day: weekday,
    startTime: currentSlot?.slots?.startTime || '',
    endTime: currentSlot?.slots?.endTime || '',
    isOpenAllDay: currentSlot?.slots?.isOpenAllDay || false,
    isClosed: currentSlot?.slots?.isClosed || false,
  })

  const handleChangeWeek = (event) => {
    const day = (event.target as HTMLElement)
      .closest('[data-id]')
      ?.getAttribute('data-id')
    if (!!day) {
      const currentSlot = user?.availabilities?.find(
        (availability) => availability?.day == day,
      )

      setInitialValues({
        ...initialValues,
        id: currentSlot?.id || null,
        day: day,
        startTime: currentSlot?.slots?.startTime || '',
        endTime: currentSlot?.slots?.endTime || '',
        isOpenAllDay: currentSlot?.slots?.isOpenAllDay || false,
        isClosed: currentSlot?.slots?.isClosed || false,
      })
    }
  }

  const submitHandler = async (values, { resetForm }) => {
    setLoading(true)
    const payload = {
      day: values?.day,
      slots: {
        startTime: values?.startTime,
        endTime: values?.endTime,
        isOpenAllDay: values?.isOpenAllDay || false,
        isClosed: values?.isClosed || false,
      },
    }
    if (!!values?.id) {
      await Availability.update({
        data: payload,
        id: values?.id,
      })
        .then((resp) => {
          const findIndex = user?.availabilities?.findIndex(
            (availability: any) => availability?.day == resp?.day,
          )
          const updatedAvailabilities = [...user?.availabilities]
          updatedAvailabilities[findIndex] = resp
          store.dispatch(
            Actions.set('user', {
              ...user,
              availabilities: updatedAvailabilities,
            }),
          )
          resetForm()
          setVisible(false)
        })
        .catch(() => {})
    } else {
      await Availability.create({
        data: payload,
      })
        .then((resp) => {
          const findIndex = Constant.weekDays?.findIndex(
            (day: any) => day?.label == resp?.day,
          )
          const updatedAvailabilities = [...user?.availabilities]
          updatedAvailabilities[findIndex] = resp
          store.dispatch(
            Actions.set('user', {
              ...user,
              availabilities: updatedAvailabilities,
            }),
          )
          resetForm()
          setVisible(false)
        })
        .catch(() => {})
    }

    setLoading(false)
  }

  return (
    <>
      <FieldOverview
        title="Our Available Hours"
        icon="edit"
        onClick={() => {
          setVisible(true)
        }}
      >
        <StyleAvailabilityWrapper>
          <StyleAvailabilityItems onClick={handleChangeWeek}>
            {Constant.weekDays?.map((week: any) => {
              return (
                <Fragment key={week?.label}>
                  <Column
                    rowGap={3}
                    alignItems="center"
                    styleColumn="width:60px;"
                  >
                    <StyleAvailabilityItem
                      data-id={week?.label}
                      isActive={week?.label == initialValues?.day}
                    >
                      <Typography content={week?.label[0]} size={14} />
                    </StyleAvailabilityItem>
                    <Typography
                      content={week?.label}
                      size={12}
                      tc={
                        week?.label == initialValues?.day ? 'primary' : 'text'
                      }
                    />
                  </Column>
                </Fragment>
              )
            })}
          </StyleAvailabilityItems>
          <Row colGap={20}>
            {!!initialValues?.isClosed ? (
              <Typography content="Closed" size={12} tc="danger" />
            ) : !!initialValues?.isOpenAllDay ? (
              <Typography content="Open All Day" size={12} tc="success" />
            ) : (
              <>
                <StyleTimeWrapper>
                  <Svg svg="time" size={12} />
                  <Typography content="Open Time" size={12} tc="success" />
                  <Typography
                    content={initialValues?.startTime}
                    size={12}
                    tc="text"
                  />
                </StyleTimeWrapper>
                <StyleTimeWrapper>
                  <Svg svg="time" size={12} />
                  <Typography content="Close Time" size={12} tc="danger" />
                  <Typography
                    content={initialValues?.endTime}
                    size={12}
                    tc="text"
                  />
                </StyleTimeWrapper>
              </>
            )}
          </Row>
        </StyleAvailabilityWrapper>
      </FieldOverview>
      {!!visible && (
        <Modal
          visible={visible}
          title={`${!!initialValues?.id ? 'Update' : 'Add'} Availability`}
          onClose={() => {
            setVisible(false)
          }}
        >
          <Formik
            onSubmit={submitHandler}
            initialValues={initialValues}
            enableReinitialize
            validationSchema={AvailabilitySchema.institutionValidationSchema}
          >
            {({ handleSubmit }) => {
              return (
                <Form onSubmit={handleSubmit}>
                  <Column rowGap={20}>
                    <Fields.DropDown
                      name="day"
                      options={Constant.weekDays}
                      titleAsKey="label"
                      valueAsKey="label"
                      label="Day"
                    />

                    <Row colGap={20}>
                      <Fields.Input
                        type="time"
                        name="startTime"
                        label="Open time"
                      />
                      <Fields.Input
                        type="time"
                        name="endTime"
                        label="Closed time"
                      />
                    </Row>
                    <Row colGap={20}>
                      <Fields.Switch
                        name="isOpenAllDay"
                        label="Is Open All Day"
                      />
                      <Fields.Switch name="isClosed" label="Is Closed" />
                    </Row>
                    <Button
                      title="Submit"
                      styleButton="width:100%"
                      height={40}
                      loading={loading}
                      type="submit"
                    />
                  </Column>
                </Form>
              )
            }}
          </Formik>
        </Modal>
      )}
    </>
  )
}

export default Availabilities
